import { render } from "./GetMemberShipSuccess.vue?vue&type=template&id=25b36845&scoped=true"
import script from "./GetMemberShipSuccess.vue?vue&type=script&lang=js"
export * from "./GetMemberShipSuccess.vue?vue&type=script&lang=js"

import "./GetMemberShipSuccess.vue?vue&type=style&index=0&id=25b36845&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b36845"]])

export default __exports__